import { useGetCollectionImageMetaDataQuery } from '@/store/api';
/**
 * Platform-services hook for fetching collection image metadata.
 *
 * Wraps the RTK Query `useGetCollectionImageMetaDataQuery` hook with skip logic.
 * Containers should use this hook instead of importing from
 * `@/store/api` directly.
 *
 * @param collectionName - The collection name. Skips the query when falsy.
 *
 * @see src/store/api/cc/collectionsApi.ts
 */
export const useGetCollectionImageMetaData = (collectionName) => {
    const { data, isLoading, isFetching, isError, error, } = useGetCollectionImageMetaDataQuery({ collectionName }, { skip: !collectionName });
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
